<template>
  <div class="content">
    <p>
      <strong>You're all set – welcome to fixed.net!</strong>
    </p>
    <p>
      Your website <strong>{{ result.siteUrl.fqdn }}</strong> has been added to
      your account and your free cleanup task has been created<span
        v-if="result.orderNum"
      >
        (order reference <strong>#{{ result.orderNum }}</strong>)</span>.
    </p>
    <p>
      Our team of experts will start looking into your website shortly. In the
      meantime, head to your task to tell us a little more about the problem
      and securely share your website logins – the more we know, the faster we
      can get you fixed.
    </p>
    <router-link
      :to="{ path: ctaPath }"
      class="button is-success has-margin-top-50"
    >
      <strong>{{ result.taskId ? "Go to my task" : "Go to my website" }}</strong>
    </router-link>
  </div>
</template>

<script>
import confetti from "canvas-confetti";

// Fixed teal ($primary) and white
const CONFETTI_COLORS = ["#00c6ce", "#ffffff"];

export default {
  name: "GoogleCleanupConfirmationStep",
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      result: null,
      confettiTimeout: null
    };
  },
  computed: {
    /* The task is the natural next step; fall back to the site dashboard on
    the off-chance the flow completed without a task id. */
    ctaPath() {
      return this.result.taskId
        ? `/tasks/${this.result.taskId}`
        : `/sites/${this.result.siteId}`;
    }
  },
  created() {
    this.result = this.$_.cloneDeep(this.payload);
  },
  mounted() {
    confetti({
      particleCount: 120,
      spread: 75,
      origin: { y: 0.3 },
      colors: CONFETTI_COLORS,
      disableForReducedMotion: true
    });
    this.confettiTimeout = setTimeout(() => {
      confetti({
        particleCount: 60,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.65 },
        colors: CONFETTI_COLORS,
        disableForReducedMotion: true
      });
      confetti({
        particleCount: 60,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.65 },
        colors: CONFETTI_COLORS,
        disableForReducedMotion: true
      });
    }, 300);
  },
  beforeDestroy() {
    clearTimeout(this.confettiTimeout);
    confetti.reset();
    this.$emit("reset");
  }
};
</script>
